import {
    GET_FINYEAR_COMPANIES,
    FINYEAR_COMPANY_REQUEST,
    FINYEAR_COMPANY_REQUEST_FAILURE,
    GET_FINYEAR_USERS
} from "../types";

const initialState = {
    finyearCompanies: [],
    finyearUsers: [],
    loading: false,
    error: null,
};

const finyearCompanyReducer = (state = initialState, action) => {
    switch (action.type) {
        case FINYEAR_COMPANY_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null
            }
        }
        case GET_FINYEAR_COMPANIES: {
            return {
                ...state,
                finyearCompanies: [...action.payload],
                loading: false,
                error: null
            }
        }
        case GET_FINYEAR_USERS: {
            return {
                ...state,
                finyearUsers: [...action.payload],
                loading: false,
                error: null
            }
        }
        case FINYEAR_COMPANY_REQUEST_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.error
            }
        }
        default:
            return state;
    }
};

export default finyearCompanyReducer;
